<template>
  <el-badge is-dot :hidden="hasfilter">
    <el-button type="info" size="mini" plain @click="dialog = true">Filtrar</el-button>
    <el-drawer title="Filtro de Auditoria" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer"
      size="50%" :wrapperClosable="false" :append-to-body="true" :modal-append-to-body="false" :modal="true">
      <div class="demo-drawer__content" style="padding: 10px">
        <el-form :model="filter" label-position="top" size="mini">
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Objeto">
                <el-input v-model="filter.tag" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Cartão de portagem">
                <el-input v-model="filter.cardpost" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12">
              <el-form-item label="Serviço">
                <ServicesList v-model="filter.service" v-bind:multiple="true" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Cliente">
                <CustomerList v-model="filter.customer" v-bind:multiple="true" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Período">
                <el-date-picker v-model="filter.range" type="daterange" align="right" unlink-panels clearable
                  range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio"
                  end-placeholder="Fim"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Ordenar por data de postagem:">
                <el-radio label="DESC" v-model="filter.orderByDate">Mais recentes</el-radio>
                <el-radio label="ASC" v-model="filter.orderByDate">Mais antigos</el-radio>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
        <div class="demo-drawer__footer" style="padding-top: 10px;">
          <el-button @click="$refs.drawer.closeDrawer();">Cancelar</el-button>
          <el-button type="info" @click="$refs.drawer.closeDrawer(); clear();">
            Limpar filtros
          </el-button>

          <el-button type="primary" @click=" $refs.drawer.closeDrawer(); execute();">
            Filtrar
          </el-button>
        </div>
      </div>
    </el-drawer>
  </el-badge>
</template>

<script>
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";

export default {
  components: {
    CustomerList,
    ServicesList
  },
  data() {
    return {
      dialog: false,
      filter: {
        tag: "",
        customer: '',
        service: '',
        cardpost: '',
        range: [],
        orderByDate: undefined
      },
    }
  },
  computed: {
    hasfilter() {
      const vm = this;
      return !(
        vm.filter.tag ||
        vm.filter.customer ||
        vm.filter.cardpost ||
        vm.filter.service ||
        vm.filter.range ||
        vm.filter.orderByDate
      );
    },
  },
  methods: {
    get() {
      return this.filter;
    },
    open() {
      const vm = this;
      vm.dialog = true;
    },
    close() {
      const vm = this;
      vm.dialog = false;
    },
    execute() {
      const vm = this;
      vm.$emit("filter");
      vm.dialog = false;
    },
    clear() {
      const vm = this;

      vm.filter.tag = "";
      vm.filter.cardpost = "";
      vm.filter.customer = "";
      vm.filter.service = "";
      vm.filter.range = [];
      vm.filter.orderByDate = undefined;
    },
  }
}
</script>